import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["width", "height", "viewBox"];
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  "clip-path": "url(#clip0_2370_75268)"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M2.9987 14.6654V11.332M2.9987 4.66536V1.33203M1.33203 2.9987H4.66536M1.33203 12.9987H4.66536M8.66536 1.9987L7.50925 5.00461C7.32124 5.49343 7.22723 5.73784 7.08105 5.94342C6.95149 6.12563 6.7923 6.28482 6.61009 6.41438C6.4045 6.56057 6.16009 6.65457 5.67127 6.84258L2.66536 7.9987L5.67127 9.15482C6.16009 9.34282 6.4045 9.43683 6.61009 9.58301C6.7923 9.71257 6.95149 9.87177 7.08105 10.054C7.22723 10.2596 7.32124 10.504 7.50925 10.9928L8.66536 13.9987L9.82148 10.9928C10.0095 10.504 10.1035 10.2596 10.2497 10.054C10.3792 9.87177 10.5384 9.71257 10.7206 9.58301C10.9262 9.43683 11.1706 9.34282 11.6595 9.15482L14.6654 7.9987L11.6595 6.84258C11.1706 6.65457 10.9262 6.56057 10.7206 6.41438C10.5384 6.28482 10.3792 6.12563 10.2497 5.94342C10.1035 5.73784 10.0095 5.49343 9.82148 5.00461L8.66536 1.9987Z",
  "stroke-width": "1.4",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
})], -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_2370_75268"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "16",
  height: "16",
  fill: "white"
})])], -1);
const _hoisted_4 = [_hoisted_2, _hoisted_3];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_center_wrapper = _resolveComponent("center-wrapper");
  return _openBlock(), _createBlock(_component_center_wrapper, null, {
    default: _withCtx(() => [(_openBlock(), _createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: $props.width,
      height: $props.height,
      viewBox: `0 0 ${$props.width} ${$props.height}`,
      fill: "none"
    }, _hoisted_4, 8, _hoisted_1))]),
    _: 1
  });
}